import { Phone, MessageCircle } from "lucide-react";
import { InquiryForm } from "./InquiryForm";
import { PHONE_DISPLAY, TEL_HREF, WHATSAPP_HREF, VIBER_HREF } from "../../lib/contact";

const chip = "inline-flex items-center gap-2 border-2 border-navy px-4 py-2 font-semibold transition-colors hover:bg-navy hover:text-ivory";

export const ContactSection = () => (
  <section id="contact" data-testid="contact-section" className="bg-sand text-navy py-24 md:py-32 pb-40 md:pb-32">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[300px_1fr] gap-12">
      <div className="min-w-0">
        <a href={TEL_HREF} data-testid="contact-phone-link" className="disp text-burgundy tab block whitespace-nowrap hover:text-coral-deep transition-colors" style={{ fontSize: "clamp(40px,4vw,52px)", lineHeight: 1 }}>
          {PHONE_DISPLAY}
        </a>
        <p className="text-lg mt-4">Hívjon bátran, vagy írjon WhatsAppon / Viberen.</p>
        <div className="mt-6 flex flex-wrap gap-3 text-base">
          <a href={TEL_HREF} data-testid="contact-call-chip" className={chip}><Phone className="h-4 w-4" /> Hívás</a>
          <a href={WHATSAPP_HREF} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-chip" className={chip}><MessageCircle className="h-4 w-4" /> WhatsApp</a>
          <a href={VIBER_HREF} data-testid="contact-viber-chip" className={chip}><MessageCircle className="h-4 w-4" /> Viber</a>
        </div>
      </div>
      <div className="min-w-0">
        <h2 className="disp uppercase" style={{ fontSize: "clamp(32px,4vw,52px)", lineHeight: 1.12 }}>
          KÉRJEN DÍJMENTES ÉS BIZALMAS TÁJÉKOZTATÁST
        </h2>
        <p className="text-xl mt-4">Kötelezettségek nélkül. Visszahívjuk egy barátságos beszélgetésre.</p>
        <InquiryForm />
      </div>
    </div>
  </section>
);
